import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MAX_NUM_TASK_LINKS, CROSS_BASELINE_SEARCH_URL_PARAMS } from '../../../../constants/constants';
import { RouteWithParams } from '../../../../helpers/routing';
import Routes from '../../../../constants/routes';
import { TruncateText } from '../../../../helpers/strings';
import TextArea from '../../../Common/TextArea';
import Toggle from '../../../Common/Toggle/Toggle';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import Icon from '../../../Common/Icon';
import './CrossBaselineTaskForm.scss';

export default class CrossBaselineTaskForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isRelationshipDrawerOpen: false,
            relationshipBaselineTaskId: null,
            showMore: false,
            markAsDependent: (this.props.task.contingentId) ? true : false,
            linkAsPrereq: (this.props.task.prereqTasks && this.props.task.prereqTasks.length > 0) ? true : false,
            taskSearchTerm: "",
            targetWeeks: 0,
            targetDays: 0,
            startWeeks: 0,
            startDays: 0,
            populateTaskName: false,
            populateAdditionalInfo: false
        }
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    onFormChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onDropdownChange = (id, name) => {
        this.props.onFormChange(name, id);
    }

    onMilestoneChange = (value, name) => {
        this.props.onFormChange(name, value);
    }

    onTaskSearchKeyDown = (e) => {
        switch (e.keyCode) {
            case 13: // enter
                e.preventDefault();
                if (e.target.defaultValue && e.target.defaultValue.length >= 3) {
                    this.props.taskSearch(e.target.defaultValue);
                }
                break;
        }
    }

    onDatePickerChange = (date, name) => {
        this.props.onFormChange(name, date);
    }

    showMore = () => {
        this.setState({ showMore: !this.state.showMore });
    }

    addLink = () => {
        let links = this.props.task.links.slice();
        if (links.length < MAX_NUM_TASK_LINKS) {
            links.push({
                id: 0,
                name: '',
                url: '',
                isActive: true,
                ordinal: links.length,
                isFile: false
            });
            this.props.onFormChange("links", links);
        }
    }

    addFileLink = () => {
        let links = this.props.task.links.slice();
        if (links.length < MAX_NUM_TASK_LINKS) {
            links.push({
                id: 0,
                name: '',
                url: '',
                isActive: true,
                ordinal: links.length,
                isFile: true
            });
            this.props.onFormChange("links", links);
        }
    }

    onMarkAsDependent = () => {
        this.setState(
            prevState => ({ markAsDependent: !prevState.markAsDependent,  })
        );
    }

    showRelationshipDrawer = (baselineTaskId) => {
        this.setState({ relationshipBaselineTaskId: baselineTaskId,  isRelationshipDrawerOpen: true });
    }

    onRelationshipDrawerComplete = () => {
        this.setState({ relationshipBaselineTaskId: null, isRelationshipDrawerOpen: false });
    }



    onDragEnd(result) {

        // dropped outside the step list area
        if (!result.destination) {
            return;
        }

        const steps = Array.from(this.props.task.steps);
        const [removed] = steps.splice(result.source.index, 1);

        steps.splice(result.destination.index, 0, removed);

        // it could move up or down in the array, only update the ones needed
        const updateStartIndex = (result.destination.index > result.source.index) ? result.source.index : result.destination.index;

        // update the ordinal of any other steps after it in the array
        for (let i = updateStartIndex; i < steps.length; i++) {
            steps[i].ordinal = i;
        }
        this.props.onFormChange("steps", steps);

    }

    isCertificationToggleDisabled = () => {
        if(!this.props.formFilters.certifiedTaskId){
            return false;
        }else{
            if(this.props.formFilters.certifiedTaskId != this.props.task.id){
                return true;
            }else {
                return false;
            }
        }
    }

    onLinkChange = (link, index, field, event) => {
        let links = this.props.task.links.slice();
        link[field] = event.target.value;
        links.splice(index, 1, link);
        this.props.onFormChange("links", links);
    }

    onFileLinkChange = (link, index, url) => {
        const selectedFile = this.props.formFilters.subscriptionFiles.find(m => m.url === url);

        let links = this.props.task.links.slice();
        link.name = selectedFile.name;
        link.url = url;
        link.customerFileId = selectedFile.id;
        links.splice(index, 1, link);
        this.props.onFormChange("links", links);
    }

    
    onSameNameClick = () => {
        RouteWithParams(Routes.CrossBaselineSearch, [
            { 
                key: CROSS_BASELINE_SEARCH_URL_PARAMS.name,
                value: this.props.task.name.trim()
            }
        ], true);
    }

    onPopulateAdditionalInfo = () => {
        this.setState({ populateAdditionalInfo: !this.state.populateAdditionalInfo });
    }

    onPopulateTaskName = () => {
        this.setState({ populateTaskName: !this.state.populateTaskName });
    }

    renderNameOptions(){
        let options = [];
        this.props.checkedTasks.forEach(function (option) {
            if(option.name) {
                options.push(
                    <option key={option.id} value={option.id}>{option.name}</option>
                ); 
            }
        });
        return options;
    }

    renderAdditionalInfoOptions(){
        let options = [];
        this.props.checkedTasks.forEach(function (option) {
            if(option.additionalInfo) {
                options.push(
                    <option key={option.id} value={option.id}>{option.additionalInfo}</option>
                ); 
            }                       
        });
        return options;
    }

    onSelectNameToUpdate = (e) => {
        const task = this.props.checkedTasks.find(x => x.id.toString() === e.target.value);
        this.setState({ populateTaskName: !this.state.populateTaskName });
        this.props.onFormChange("name", task.name);
    }

    onSelectAdditionalInfoToUpdate = (e) => {
        const task = this.props.checkedTasks.find(x => x.id.toString() === e.target.value);
        this.setState({ populateAdditionalInfo: !this.state.populateAdditionalInfo });
        this.props.onFormChange("additionalInfo", task.additionalInfo);
    }


    render() {
        const milestoneInputText = (this.props.task.isMilestone === 'true') ? "Milestone Task Name" : "Task Name";

        const sameNameLabel = (this.props.task.sameNameCount > 1) ? `There are ${this.props.task.sameNameCount} additional active baseline tasks with this same name.` : `There is ${this.props.task.sameNameCount} additional active baseline task with this same name.`;
        return (
            <div className="baseline-task-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                    {this.props.task.sameNameCount && this.props.task.sameNameCount > 0 ?
                        <div className="alert alert-warning text-center">
                            <span>{sameNameLabel}</span>
                            <span className="alert-icon ms-2" onClick={this.onSameNameClick} ><Icon name="external-link-alt" /></span>
                        </div>
                        :
                        null
                    }
                    {this.props.task.contingentId &&
                        <div className="alert alert-secondary contingent-alert">
                            <div className="contingent-alert-link">
                                This task is a prerequisite of: <a href="#" onClick={() => this.showRelationshipDrawer(this.props.task.contingentId)}>{TruncateText(this.props.task.contingentName, 20)}</a> 
                            </div>
                            <div className="contingent-alert-remove">
                                <button type="button" className="remove-dependent btn btn-link" onClick={this.onSuccessorRemove}>Remove dependency</button>
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-sm-12">
                            <p>All selected tasks will be updated with the following information. Leave unchanging fields blank.</p>
                            <span className="task-name" onClick={this.onPopulateTaskName}>Populate {milestoneInputText}</span>                            
                            <TextArea rows={2} name="name" label={milestoneInputText} placeholder={milestoneInputText} value={this.props.task.name} isRequired={true} errorMessage="Name is required" onChange={this.onFormChange} />
                            { this.state.populateTaskName &&
                            <div className="row">
                                <div className="col mb-3">
                                    <span className="has-float-label">
                                        <select id="taskNameContainer" className="form-control mt-3" multiple size="8" onClick={this.onSelectNameToUpdate}>
                                            {this.renderNameOptions()}
                                        </select>
                                        <label htmlFor="taskNameContainer">Select Task Name</label>
                                    </span>
                                </div>
                            </div> 
                            }  
                            <span className="task-name" onClick={this.onPopulateAdditionalInfo}>Populate Additional Info</span>
                            <TextArea rows={2} name="additionalInfo" placeholder="Additional Info" label="Additional Info" value={this.props.task.additionalInfo} onChange={this.onFormChange} />                          
                            { this.state.populateAdditionalInfo &&
                            <div className="row">
                                <div className="col mb-3">
                                    <span className="has-float-label">
                                        <select id="additionalInfoContainer" className="form-control mt-3" multiple size="8" onClick={this.onSelectAdditionalInfoToUpdate}>
                                            {this.renderAdditionalInfoOptions()}
                                        </select>
                                        <label htmlFor="additionalInfoContainer">Select Additional Info</label>
                                    </span>
                                </div>
                            </div> 
                            } 

                            

                            <MultiSelectBox 
                                name="jobTitleId" 
                                label="Baseline Job Titles" 
                                options={this.props.formFilters.baselineJobTitles} 
                                idField="id" 
                                valueField="name" 
                                selectedValues={this.props.task.jobTitleId.toString()} 
                                onChange={this.onDropdownChange}  
                                errorMessage="Baseline Job Title is required"
                                isMulti={false}
                            />

                            <MultiSelectBox 
                                name="departmentId" 
                                label="Department" 
                                options={this.props.formFilters.departments} 
                                idField="id" 
                                valueField="name" 
                                selectedValues={this.props.task.departmentId.toString()} 
                                onChange={this.onDropdownChange} 
                                errorMessage="Department is required"
                                isMulti={false}
                            />

                            <MultiSelectBox 
                                name="communityId" 
                                label="Community" 
                                options={this.props.formFilters.communities} 
                                idField="id" 
                                valueField="name" 
                                selectedValues={this.props.task.communityId.toString()} 
                                onChange={this.onDropdownChange} 
                                errorMessage="Community is required"
                                isMulti={false}
                            />
                            <MultiSelectBox 
                                name="taskTagIds" 
                                label="Additional Task Tag" 
                                options={this.props.formFilters.taskTags} 
                                idField="id" 
                                valueField="name" 
                                selectedValues={this.props.task.taskTagIds.toString()} 
                                onChange={this.onDropdownChange}
                                isMulti={true}
                            />
                            <MultiSelectBox 
                                name="phaseId" 
                                label="Phase" 
                                options={this.props.formFilters.phases} 
                                idField="id" 
                                valueField="name" 
                                selectedValues={this.props.task.phaseId.toString()} 
                                onChange={this.onDropdownChange}
                                isMulti={false}
                            />
                            <MultiSelectBox 
                                name="isMilestone" 
                                label="Milestone" 
                                options={
                                    [
                                        { id: 'true', name: 'Update selected to be a Milestone' },
                                        { id: 'false', name: 'Update selected to Not be a Milestone' },
                                    ]
                                } 
                                idField="id" 
                                valueField="name" 
                                selectedValues={this.props.task.isMilestone ? this.props.task.isMilestone : ''} 
                                onChange={this.onMilestoneChange}  
                                isRequired={false}
                                isMulti={false}
                            />
                            <div className="toggle-wrapper">
                                    <Toggle
                                        name="isTrickleDown"
                                        text="Update location tasks with new selection"
                                        checked={this.props.task.isTrickleDown}
                                        onChange={this.onToggleChange}
                                    />
                                    <div ref={this.infoRef}
                                        data-toggle="popover"
                                        title="Information"
                                        data-placement="bottom"
                                        data-content="Turn OFF if you want to only update the baseline with the new selection. Any locations with this task will not change. Turn ON if you want to update the baseline and any location with this task with the new selection"
                                    >
                                        <Icon name="info-circle" />
                                    </div>
                                </div>
                        </div>                        
                    </div>
                </form>
            </div>
        );
    }
}

CrossBaselineTaskForm.propTypes = {
    task: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    showDateError: PropTypes.bool.isRequired,
    onFormChange: PropTypes.func.isRequired,   
    formFilters: PropTypes.object.isRequired,
    taskSearch: PropTypes.func.isRequired,
    taskSearchResults: PropTypes.array.isRequired,
    baselineTaskActions: PropTypes.object.isRequired,
    checkedTasks: PropTypes.array.isRequired
}
